import {useLocation, useNavigate, useParams} from "react-router-dom";
import React, { useEffect, useState } from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import {getOfficeById, getOfficeTypes, updateOffice} from "../../actions/Office";

interface OfficeType {
    id: number;
    name: string;
}

interface FormData {
    type: number;
    province: string;
    address_line_1: string;
    address_line_2: string;
    address_line_3: string;
    postal_code: string;
    tel: string;
    geo_url: string;
}

function EditOffice() {
    const location = useLocation();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }
    const { id } = useParams<{id?: string }>();

    const [formData, setFormData] = useState<FormData>({
        type: 1,
        province: "",
        address_line_1: "",
        address_line_2: "",
        address_line_3: "",
        postal_code: "",
        tel: "",
        geo_url: ""
    });

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();


        try {
            const formDataToSend = new FormData();

            // Append basic form data
            Object.keys(formData).forEach(key => {
                const value = formData[key as keyof FormData];
                if (value !== null && value !== undefined) {
                    formDataToSend.append(key, value.toString());
                }
            });

            // Call the actual API method
            const response = await updateOffice(formDataToSend, Number(id));

            if (response.data?.success) {

                navigate('/dashboard/offices/list', {state: {user}});
                // Optionally: reset form here if needed
                // setFormData(initialFormData);
            } else {
                // Handle possible failure even with 200 OK response
                console.log([response.data?.message || "An unexpected error occurred"]);
            }

        } catch (error: any) {
            console.error("Error submitting form:", error);
            // If the server returned validation errors:
            if (error.response?.data?.errors) {
                const errorMessages = Object.values(error.response.data.errors).flat();
                console.log(errorMessages);
            } else {
                console.log(["An error occurred while submitting the form"]);
            }
        }
    };

    const handleInputChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const [officeTypes, setOfficeTypes] = useState<OfficeType[]>([]);

    useEffect(() => {
        getOfficeTypes()
            .then(response => {
                setOfficeTypes(response.data);
            })
            .catch(error => {
                console.error("Failed to fetch offices:", error);
            });

        getOfficeById(Number(id))
            .then(response => {

                setFormData({
                    type: response.data.data.office_type_id,
                    province: response.data.data.province,
                    address_line_1: response.data.data.address_line_1,
                    address_line_2: response.data.data.address_line_2,
                    address_line_3: response.data.data.address_line_3,
                    postal_code: response.data.data.postal_code,
                    tel: response.data.data.tel,
                    geo_url: response.data.data.geo_url,
                })
            })
            .catch(error => {
                console.error("Failed to fetch office:", error);
            });
    }, []);



    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />
            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <h2>Add New Office</h2>
                <form
                    className="form-horizontal form-label-left"
                    onSubmit={handleSubmit}
                    encType="multipart/form-data"
                    style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
                >
                    {/* Office Type Dropdown */}
                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <select
                            name="type"
                            value={formData.type}
                            onChange={handleInputChange}
                            className="input-email"
                            required
                        >
                            {officeTypes.map((type) => (
                                <option key={type.id} value={type.id}>
                                    {type.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* Province Input */}
                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Province"
                            id="province"
                            name="province"
                            value={formData.province}
                            onChange={handleInputChange}
                            required
                        />
                    </div>

                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Address Line 1"
                            id="address_line_1"
                            name="address_line_1"
                            value={formData.address_line_1}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Address Line 2"
                            id="address_line_2"
                            name="address_line_2"
                            value={formData.address_line_2}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="address_line_3"
                            id="address_line_3"
                            name="address_line_3"
                            value={formData.address_line_3}
                            onChange={handleInputChange}
                        />
                    </div>
                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Postal Code"
                            id="postal_code"
                            name="postal_code"
                            value={formData.postal_code}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="content-form-field" style={{ marginBottom: '10px' }}>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Telephone"
                            id="tel"
                            name="tel"
                            value={formData.tel}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="content-form-field">
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Google Maps Location"
                            id="geo_url"
                            name="geo_url"
                            value={formData.geo_url}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <label style={{fontSize: '12px', marginBottom: '10px', textAlign: 'left', color: "#73879C"}}>
                        eg. goo.gl/maps/jXP2q6SPZriU3KNs6
                    </label>

                    <div className="form-group" style={{ marginBottom: '0' }}>
                        <div className="col-md-12 col-sm-12 col-xs-12">
                            <button type="submit" className="btn btn-success">
                                Submit
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditOffice;
